import { lang, commonLang } from '@umu/ukit-lang';
/**
 * @description
 */

import './rewardInputDialog.scss';

import React, { useState, useRef } from 'react';
import { components, services } from 'common';
const { Dialog, DialogHeader, DialogBody, DialogFooter, DialogFooterButton } = components;
const { Toast } = services;

function format(value: string) {
    const regex = /^[0-9]+\.([0-9]+)?$/;

    if (!isNaN(+value) && +value) {
        value = +value + '';
    }

    if (regex.test(value)) {
        value = (+value).toFixed(2);
    }

    return value;
}

function validate(value: string, min: number = 1, max: number = 10e7) {
    let valid = true;
    const regex = /^[0-9]+(.[0-9]*)?$/;
    if (value) {
        const val = +value;
        if (!regex.test(val + '')) {
            valid = false;
        }
        if (val > max || val < min) {
            valid = false;
        }
    }
    return valid;
}

interface IProps {
    min: number;
    max: number;
    clsName?: string;
    amount?: string;
    onSave(val: string): void;
    onClose(): void;
}

export default function RewardInputDialog(props: IProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [isValid, setIsValid] = useState(true);

    const onFormat = () => {
        if (!inputRef.current) {
            return;
        }
        let value = inputRef.current.value.trim();

        value = format(value);

        inputRef.current.value = value;
        onValidate();
    };

    const onValidate = () => {
        if (!inputRef.current) {
            return;
        }

        let valid;

        const value = inputRef.current.value && inputRef.current.value.trim();
        const min = props.min;
        const max = props.max;

        valid = validate(value, min, max);

        setIsValid(valid);

        return valid;
    };

    const onSubmit = () => {
        if (!inputRef.current) {
            return;
        }

        const value = inputRef.current.value.trim();
        if (!value) {
            Toast.show(lang('请输入金额'));
            return;
        }

        if (isValid) {
            props.onSave(value);
            props.onClose();
        }
    };
    const render = () => {
        const dialogClsName = 'input-dialog ' + (props.clsName || '');

        const info = (
            <div className="amount-input">
                <div className="input-box input-text">
                    <input
                        type="tel"
                        className="input-text"
                        maxLength={8}
                        onBlur={onFormat}
                        defaultValue={props.amount}
                        placeholder={lang('可填写 1 - 9999（元）')}
                        ref={inputRef}
                    />
                </div>
                {isValid ? null : <div className="input-check">{lang('请输入金额')}</div>}
            </div>
        );

        return (
            <Dialog show={true} hasMask={true} className={dialogClsName} canClose={false}>
                <DialogHeader>
                    <div className="title">{lang('其他金额')}</div>
                </DialogHeader>
                <DialogBody>
                    <div className="info">{info}</div>
                </DialogBody>
                <DialogFooter>
                    <DialogFooterButton className="btn optional" onClick={props.onClose}>
                        {commonLang('取消')}
                    </DialogFooterButton>
                    <DialogFooterButton className="btn btn-primary" onClick={onSubmit}>
                        {commonLang('确定')}
                    </DialogFooterButton>
                </DialogFooter>
            </Dialog>
        );
    };
    return render();
}
